export const StatusType = {
    ATIVO: 'Ativo',
    INATIVO: 'Inativo'
  };
  